export default "__VITE_ASSET__Dl_EcGSb__"